import React from 'react';
import { TooltipRenderProps } from 'react-joyride';
import { useTranslation } from 'react-i18next';

export const createCustomTooltip = (primaryColor: string) => {
    const CustomTooltip: React.FC<TooltipRenderProps> = ({ continuous, index, step, backProps, closeProps, primaryProps, tooltipProps, isLastStep, size, skipProps }) => {
        const { t } = useTranslation();

        return (
            <div
                {...tooltipProps}
                style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                    border: '1px solid #e5e7eb',
                    padding: '20px',
                    maxWidth: '420px',
                    minWidth: '300px',
                    position: 'relative',
                }}
            >
                {step.title && (
                    <div
                        style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            color: '#1f2937',
                            marginBottom: '8px',
                        }}
                    >
                        {step.title}
                    </div>
                )}
                <div
                    style={{
                        fontSize: '14px',
                        lineHeight: 1.5,
                        color: '#6b7280',
                        marginBottom: '16px',
                    }}
                >
                    {step.content}
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '16px',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {!isLastStep && (
                            <button
                                {...skipProps}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    color: '#6b7280',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    padding: '8px 0',
                                }}
                            >
                                {t('skip_tour')}
                            </button>
                        )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {index > 0 && (
                            <button
                                {...backProps}
                                style={{
                                    backgroundColor: 'transparent',
                                    borderRadius: '8px',
                                    color: '#6b7280',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    padding: '8px 16px',
                                    border: '1px solid #d1d5db',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                {t('back')}
                            </button>
                        )}
                        <button
                            {...primaryProps}
                            style={{
                                backgroundColor: primaryColor,
                                borderRadius: '8px',
                                color: '#ffffff',
                                fontSize: '14px',
                                fontWeight: 500,
                                padding: '8px 16px',
                                border: 'none',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                        >
                            {isLastStep ? t('finish') : `${t('next')} (${t('sw_page.step_x_of_y', { current: String(index + 1), total: String(size) })})`}
                        </button>
                    </div>
                </div>
            </div>
        );
    };
    return CustomTooltip;
};
